import { Handle, Position } from "@xyflow/react";
import Tooltip from "@mui/material/Tooltip";

const CustomNode = ({ data }: any) => {
  return (
    <Tooltip
      title={data.tooltip}
      PopperProps={{
        container: document.getElementById("chain_modal"),
      }}
      arrow
      placement="top"
      componentsProps={{
        tooltip: {
          sx: {
            zIndex: 99999999999,
            backgroundColor: "#000000ad",
            color: "white",
            fontSize: 16,
            border: "1px solid #ffffff20",
            padding: "8px 12px",
          },
        },
      }}
    >
      <div
        style={{
          pointerEvents: "auto",
          background: data.backgroundColor,
          color: "#ffffff",
          padding: 0,
          borderRadius: 8,
          width: 100,
          height: data.height,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: "bold",
          boxShadow: data.boxShadow,
        }}
      >
        {data.label}
        <Handle type="source" position={Position.Right} />
        <Handle type="target" position={Position.Left} />
      </div>
    </Tooltip>
  );
};

export default CustomNode;
